import React from "react";
import { Button } from "reactstrap";

type Props = Readonly<{
  disabled: boolean;
  onCancel: () => void;
  onClear: () => void;
  onReset: () => void;
  onSubmit: () => void;
}>;

export const Controls = ({ disabled, onCancel, onClear, onReset, onSubmit }: Props) => {
  return (
    <div className="bg-dark controls">
      <Button color="secondary" onClick={onCancel}>
        Cancel
      </Button>
      <Button color="danger" disabled={disabled} onClick={onReset}>
        Reset
      </Button>
      <Button color="warning" disabled={disabled} onClick={onClear}>
        Clear
      </Button>
      <Button color="primary" onClick={onSubmit}>
        Done
      </Button>
    </div>
  );
};
Controls.displayName = "Controls";
